'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentMastercardLogoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M49.6906 42.0159H34.6994V15.2427H49.6906V42.0159Z",
          fill: "#FF5F00"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.6598 28.6271C35.6598 23.1961 38.2187 18.3582 42.2036 15.2405C39.2896 12.9607 35.6119 11.6 31.615 11.6C22.1529 11.6 14.4828 19.2232 14.4828 28.6271C14.4828 38.0311 22.1529 45.6543 31.615 45.6543C35.6119 45.6543 39.2896 44.2936 42.2036 42.0137C38.2187 38.896 35.6598 34.0582 35.6598 28.6271Z",
          fill: "#EB001B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M69.9092 28.6271C69.9092 38.0311 62.239 45.6543 52.7769 45.6543C48.7801 45.6543 45.1024 44.2936 42.1873 42.0137C46.1732 38.896 48.7321 34.0582 48.7321 28.6271C48.7321 23.1961 46.1732 18.3582 42.1873 15.2405C45.1024 12.9607 48.7801 11.6 52.7769 11.6C62.239 11.6 69.9092 19.2232 69.9092 28.6271Z",
          fill: "#F79E1B"
        }
      )
    ]
  }
);
const VpPaymentMastercardLogoAsset = forwardRef(PaymentMastercardLogoAsset);

export { VpPaymentMastercardLogoAsset as default };
